import React, { useState, useRef, useCallback, useEffect } from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import Modal from 'react-bootstrap/Modal';
import 'emoji-mart/css/emoji-mart.css';
import { FOLLOW_STATUS, ROLES } from '../../utils/constants';
import { connect, useDispatch } from 'react-redux';
import { reorderConvListR, updateShowPriceR, setConvIndexR, setAlert, updateMuteOther, updateConvListR, updateActiveConvR } from '../../../redux/actions';
import { isDesktop } from 'react-device-detect';
import { v4 as uuidv4 } from 'uuid';
import { getStash, setStash, setStashSelectedR } from '../../../redux/actions/stash';

const PTextarea = ({
    placeholder = 'Create new post...',
    user,
    followerDetails = {},
    active,
    ppvPrice,
    setPpvPrice,
    showPrice,
    stashSelected,
    setStashSelected,
    convIndex,
    reorderConvList,
    convList,
    setAttach,
    updateShowPrice,
    setConvIndex,
    disabled = false,
    setPpvPriceError,
    minPpvPrice,
    maxPpvPrice,
    hideOnError = false,
    activeConv,
    setNewLineCount,
    setMediaFiles,
    setNewMessage,
    setInput,
    uuid,
    setUuid,
    setResponseMessage,
    freePreview,
    getStash,
    stash,
    resetMarginTop = () => { },
    hidePriceInput = () => { },
    updateMuteOtherHere,
    promoPrice,
    setPromoPrice,
    expiry,
    setAlert,
    resetPriceModal = () => { },
    ...rest
}) => {
    const [emojiPicker, setEmojiPicker] = useState(false);
    const userInformation = JSON.parse(localStorage.getItem('user'));
    const [caret, setCaret] = useState({ selectionStart: 0, selectionEnd: 0 });
    const [caption, setCaption] = useState('');
    const [nearBottom, setNearBottom] = useState(false);
    const editorRef = useRef(null);
    const [msgStatus, setMsgStatus] = useState(false);
    const [sending, setSending] = useState(false);
    const themeMode = (localStorage.getItem('darkmode') === 'true' ? 'dark' : 'light');

    useEffect(() => {
        if (!userInformation) {
            localStorage.clear();
            window.location = '/login';
        }
    }, []);

    const dispatch = useDispatch();

    useEffect(() => {
        setCaption('');
        setInput('');
        setStashSelected([]);
        setPpvPrice('');
        updateShowPrice(false);
    }, [activeConv]);

    useEffect(() => {
        if (followerDetails.status == 2) {
            setMsgStatus(true);
        } else {
            setMsgStatus(false);
        }
    }, [followerDetails]);

    const handleEmojiPicker = (e) => {
        var elRect = e.target.getBoundingClientRect();

        setEmojiPicker(!emojiPicker);
        if (elRect.top > 380) {
            setNearBottom(true);
        } else {
            setNearBottom(false);
        }
        setEmojiPicker(!emojiPicker);
    };

    const onEmojiClick = (emoji, e) => {
        let sym = emoji.unified.split('-');
        let codesArray = [];
        sym.forEach(el => codesArray.push('0x' + el));
        let theEmoji = String.fromCodePoint(...codesArray);

        setCaption((prev) => [
            prev.slice(0, caret.selectionStart),
            theEmoji,
            prev.slice(caret.selectionEnd),
        ].join(''));
        setInput((prev) => [
            prev.slice(0, caret.selectionStart),
            theEmoji,
            prev.slice(caret.selectionEnd),
        ].join(''));
        editorRef.current.focus();
        setTimeout(() => {
            editorRef.current.selectionEnd = caret.selectionEnd + 2;
        }, 1);
    };

    const submit = (e) => {
        if (e) {
            e.preventDefault();
        }

        $('#createpost-with-emoji-textarea').focus();

        if (sending) {
            return false;
        }

        if (caption.trim().length <= 0 && stashSelected.length == 0) {
            setAlert({
                type: 'error',
                show: true,
                body: `Please add a message or select a media to send`
            });
            return false;
        }

        if (ppvPrice > 0 && stashSelected.length == 0) {
            setAlert({
                type: 'error',
                show: true,
                body: `Please select a media from stash`
            });
            return false;
        }

        if (parseFloat(promoPrice) > parseFloat(ppvPrice)) {
            setAlert({
                type: 'error',
                show: true,
                body: `Discounted price must be less than the actual price`
            });
            return false;
        }

        const hasFreePreview = freePreview && Object.keys(freePreview).length > 0;
        const numStashSelected = stashSelected.length;
        if (hasFreePreview && numStashSelected === 1) {
            setAlert({
                type: 'error',
                show: true,
                body: `Free preview can only be used with multiple media`
            });
            return false;
        }

        const formData = new FormData();

        formData.append('message', caption);
        formData.append('rec_id', active);
        formData.append('uuid', uuid);
        formData.append('promo_price', promoPrice);
        formData.append('expiry_date', JSON.stringify(expiry));

        setSending(true);

        if (ppvPrice > 0) {
            formData.append('ppv_price', ppvPrice);
        }
        formData.append('sender_id', localStorage.getItem('loggedin_user'));

        if (freePreview && Object.keys(freePreview).length > 0) {
            formData.append('free_preview', freePreview.media_id);
        }

        stashSelected.map((file, index) => {
            formData.append('media[]', file.media_id);
        });

        convList.map((i, index) => { //loop to check and update conv index if it has changed
            if (i.user_a == active || i.user_b == active) {
                setConvIndex(index);
            }
        });

        setNewMessage(newMessage => newMessage += 1);
        // hide price inpout in the messenger > chatwindow
        hidePriceInput();

        setCaption('');
        setTimeout(() => {
            setPpvPrice('');
            setStashSelected([]);
        }, 300);

        const payload = {
            mediaSent: [],
            mediaSold: [],
            hasMore: true,
            stashSelected: [],
            medias: [],
            tabSelected: 'media',
            albumAction: '',
            stashSidebar: false,
            busy: false
        };

        dispatch(setStash({
            ...stash,
            ...payload
        }));

        axios({
            method: 'post',
            url: '/api/messages',
            data: formData,
            headers: { 'Content-Type': 'multipart/form-data' },
        })
            .then((response) => {
                if (response.data.success) {
                    setResponseMessage(response.data.message);
                    // update conversation list on the sidebar
                    let tmp = [...convList];

                    const index = tmp.findIndex(t => t.conversation_id == response.data.message.conversation_id);
                    setConvIndex(index);

                    tmp[index] = {
                        ...tmp[index],
                        ...response.data.message
                    };

                    dispatch(updateConvListR([...tmp]));

                    setUuid(uuidv4());
                    setCaption('');
                    setInput('');
                    setPpvPriceError(false);
                    reorderConvList(convList, index, response.data.message.message);
                    setAttach([]);
                    resetPriceModal();
                    updateShowPrice(false);
                    setStashSelected([]);
                    resetMarginTop();
                    setSending(false);
                } else {
                    updateMuteOtherHere(true);
                }

            })
            .catch((error) => {
                console.error({ error });
                if (error.response && error.response.status) {
                    if (error.response.status == 422) {
                        Object.keys(error.response.data.errors).forEach((key) => {
                            if (key == 'ppv_price') {
                                setPpvPriceError(true);
                            }
                        });
                    } else {
                        setAlert({
                            show: true,
                            type: 'error',
                            body: error.response.data.message || 'Unable to send message'
                        });
                    }
                }

                setSending(false);
            });
    };

    const handleChange = (e) => {
        // e.persist();
        const value = e.target.value;
        setCaption(value);
        setInput(value);
        // const { selectionStart, selectionEnd } = e.target;
        // setCaret({ selectionStart, selectionEnd });
    };

    const detectPositionChange = useCallback(() => {
        if (editorRef.current) {
            const { selectionStart, selectionEnd } = editorRef.current;
            setCaret({ selectionStart, selectionEnd });
        }
    }, [setCaret, editorRef]);

    useEffect(() => {
        // detectPositionChange();
        const newLineCount = (caption.match(/\n/g) || '').length + 1;
        setNewLineCount(newLineCount);
    }, [caption, setCaret, detectPositionChange]);

    const [createError, setCreateError] = useState(false);
    const handleCreateError = () => setCreateError(!createError);

    const handleKeyDown = event => {
        if (event.shiftKey && isDesktop) {
            // if (event.key === 'Enter') {
            //     let tmp = JSON.parse(JSON.stringify(caption));
            //     tmp += '\n';

            //     setCaption(tmp);
            //     setInput(tmp);

            //     return;
            // }

            return;
        }

        if (!disabled && (event.key === 'Enter' || event.keyCode === 13) && isDesktop) {
            event.preventDefault();
            submit();
        }
    };

    return (
        <>
            <Modal show={createError} onHide={handleCreateError} className="createError-modal" size="md" centered>
                <Modal.Body>
                    <h6>You cannot post content or earn money from followers until you become a creator.</h6>
                    <div className="createError-modal-btns">
                        <button className="" onClick={handleCreateError}>Ok</button>
                    </div>
                </Modal.Body>
            </Modal>
            <div>
                <div className="act-text um-message-textarea">
                    <div className="createpost-text-wrapper">
                        {userInformation && userInformation.role === ROLES.SU && (user ? user.subscription_status !== FOLLOW_STATUS.ACTIVE : true) ?
                            <TextareaAutosize
                                rows={3}
                                name="post-content"
                                className="su-textarea"
                                id="createpost-with-emoji-textarea"
                                placeholder={placeholder}
                                onChange={handleChange}
                                value={caption}
                                ref={editorRef}
                                maxRows={6}
                                style={{ overflowY: 'auto' }}
                                onKeyDown={handleKeyDown}
                                disabled={disabled}
                                {...rest}
                            /> :
                            <TextareaAutosize
                                rows={3}
                                name="post-content"
                                className="pu-textarea"
                                id="createpost-with-emoji-textarea"
                                placeholder={placeholder}
                                onChange={handleChange}
                                value={caption}
                                ref={editorRef}
                                maxRows={6}
                                style={{ overflowY: 'auto' }}
                                onKeyDown={handleKeyDown}
                                disabled={disabled}
                                {...rest}
                            />
                        }
                    </div>
                </div>

                {
                    !hideOnError &&
                    <div className="chat-buttons-right">
                        {
                            disabled || (caption.length <= 0 && stashSelected && stashSelected.length <= 0) || sending
                                ? <button
                                    className={`btn btn-sm btn-primary btn-rounded btn-ppv${sending ? ' btn-sending' : ''}`}
                                    disabled
                                >
                                    Send
                                </button>
                                : <button
                                    className={`btn btn-sm btn-primary btn-rounded btn-ppv${sending ? ' btn-sending' : ''}`}
                                    onClick={submit}
                                >
                                    Send
                                </button>
                        }
                    </div>
                }
            </div>
        </>
    );
};

function mapStateToProps(state) {
    return {
        stash: state.stash,
        stashSelected: state.stash.stashSelected,
        convIndex: state.message.convIndex,
        convList: state.message.convList,
        showPrice: state.message.showPrice,
        activeConv: state.message.activeConv
    };
}

function mapDispatchToProps(dispatch) {
    return {
        setStashSelected: (stashSelected) => dispatch(setStashSelectedR(stashSelected)),
        reorderConvList: (convList, convIndex, newMsg, newTime) => dispatch(reorderConvListR(convList, convIndex, newMsg)),
        updateShowPrice: (showPrice) => dispatch(updateShowPriceR(showPrice)),
        setConvIndex: (convIndex) => dispatch(setConvIndexR(convIndex)),
        setAlert: payload => dispatch(setAlert(payload)),
        getStash: payload => dispatch(getStash(payload)),
        setStash: payload => dispatch(setStash(payload)),
        updateMuteOtherHere: (mute_other_val) => dispatch(updateMuteOther(mute_other_val)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(PTextarea));
